// client/src/pages/user/Services.js
// client/src/pages/user/Services.js
import { useEffect, useMemo, useState } from "react";
import api from "../../api/axiosInstance";

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const [platform, setPlatform] = useState("ALL");
  const [search, setSearch] = useState("");

  useEffect(() => {
    api.get("/services")
      .then((res) => {
        setServices(res.data || []);
      })
      .finally(() => setLoading(false));
  }, []);

  /* ===============================
     FILTER LOGIC (FLAT)
  =============================== */
  const filtered = useMemo(() => {
    return services.filter((s) => {
      const platformMatch =
        platform === "ALL" || s.platform === platform;

      const searchMatch =
        s.name?.toLowerCase().includes(search.toLowerCase()) ||
        String(s.providerServiceId || "").includes(search);

      return platformMatch && searchMatch;
    });
  }, [services, platform, search]);

  const platforms = ["ALL", ...new Set(services.map((s) => s.platform).filter(Boolean))];

  if (loading) return <div>Loading services…</div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Services</h1>

      {/* ================= FILTER BAR ================= */}
      <div className="flex flex-wrap gap-4 items-end">
        {/* PLATFORM */}
        <div className="flex flex-col">
          <label className="text-xs text-gray-400 mb-1">Platform</label>
          <select
            value={platform}
            onChange={(e) => setPlatform(e.target.value)}
            className="bg-black/40 border border-white/20 rounded px-3 py-2
                       focus:outline-none focus:ring-2 focus:ring-purple-500
                       min-w-[220px]"
          >
            {platforms.map((p) => (
              <option
                key={p}
                value={p}
                className="bg-black text-white"
              >
                {p}
              </option>
            ))}
          </select>
        </div>

        {/* SEARCH */}
        <div className="flex flex-col flex-1 min-w-[240px]">
          <label className="text-xs text-gray-400 mb-1">
            Search (Service name or ID)
          </label>
          <input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="e.g. YouTube, Instagram, 1047…"
            className="bg-black/40 border border-white/20 rounded px-3 py-2
                       focus:outline-none focus:ring-2 focus:ring-purple-500"
          />
        </div>
      </div>

      {/* ================= SERVICES TABLE ================= */}
      <div className="overflow-x-auto rounded-xl border border-white/10">
        <table className="w-full text-sm">
          <thead className="bg-white/10 text-gray-300">
            <tr>
              <th className="p-3">ID</th>
              <th className="p-3 text-left">Service</th>
              <th className="p-3">Min</th>
              <th className="p-3">Max</th>
              <th className="p-3">Price / 1k</th>
              <th className="p-3">Action</th>
            </tr>
          </thead>

          <tbody>
            {filtered.map((s) => (
              <tr
                key={s._id}
                className="border-t border-white/5 hover:bg-white/5"
              >
                <td className="p-3 font-mono">
                  {s.providerServiceId}
                </td>

                <td className="p-3">
                  {s.name}
                </td>

                <td className="p-3 text-center">{s.min}</td>
                <td className="p-3 text-center">{s.max}</td>

                <td className="p-3 text-center text-green-400">
                  ₹{Number(s.rate || 0).toFixed(2)}
                </td>

                <td className="p-3 text-center">
                  <a
                    href={`/new-order?service=${s._id}`}
                    className="px-3 py-1 rounded bg-purple-600 hover:bg-purple-700"
                  >
                    Order
                  </a>
                </td>
              </tr>
            ))}

            {filtered.length === 0 && (
              <tr>
                <td
                  colSpan="6"
                  className="p-6 text-center text-gray-400"
                >
                  No services found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
